<template>
  <div class="content-wrapper d-flex flex-column mb-3">
    <div class="sub-category flex-shrink-0">
      <Timeline
        ref="Timeline"
        :map="map"
        :sync="sync"
        @set-sync="setSync"
        @sync-filters="syncFilters"
      />
    </div>
    <div class="sub-category mt-2">
      <Heatmaps
        ref="Heatmaps"
        :map="map"
        :sync="sync"
        @set-sync="setSync"
        @sync-filters="syncFilters"
      />
    </div>
  </div>
</template>

<script>
import Timeline from './telemetry/timeline.vue'
import Heatmaps from './telemetry/heatmaps.vue'
export default {
  props: {
    map: {
      default() { return null }
    }
  },
  components: {
    Timeline,
    Heatmaps,
  },
  data () {
    return {
      sync: true
    }
  },
  methods: {
    syncFilters([filters, minor]) {
      this.$refs[minor][`selected${minor}Data`] = {
        ...this.$refs[minor][`selected${minor}Data`],
        ...filters
      }
    },
    setSync ([val, major, minor]) {
      this.sync = val
      if (val) {
        this.$refs[minor][`selected${minor}Data`] = {
          ...this.$refs[minor][`selected${minor}Data`],
          ...this.$refs[major][`selected${major}Data`]
        }
      }
    }
  }
}
</script>

<style scoped>
  .content-wrapper {
    height: calc(100% - 12px);
  }

  .sub-category {
    overflow-y: auto;
  }
</style>